import style from "./style.scss";
import { useState, useRef, useEffect } from "preact/hooks";
import Link from "../../link";
import MatchLink from "../../link/match";
import IconDown from "../../icons/down";
import SubMenu from "./sub-menu";
import { mergeClasses } from "../../helpers";
import namedRoutes from "../../../settings/routes";

const Navigation = () => {
  const [menuActive, setMenuActive] = useState(false);
  const navRef = useRef(null);

  const handleToggle = () => {
    setMenuActive(!menuActive);
  };

  const handleClickOutside = (event) => {
    if (navRef.current && !navRef.current.contains(event.target)) {
      // Close the menu if clicked outside
      setMenuActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <nav
      class={mergeClasses([style.nav, menuActive ? style.menuActive : null])}
      aria-label="Main navigation"
    >
      <ul>
        <li class={mergeClasses([style.topItem, style.deals])}>
          <Link href={namedRoutes.deals}>Deals</Link>
        </li>
        <li>
          <button
            class={style.toggleButton}
            aria-label="Toggle menu"
            onClick={handleToggle}
            ref={navRef}
          >
            <span class={style.buttonText}>Menu</span>
            <span class={style.buttonIcon}>
              <IconDown open={menuActive} />
            </span>
          </button>
          <ul class={style.items} role="menu">
            <li role="menuitem">
              <MatchLink activeClass={style.current} href={namedRoutes.home}>
                All Reviews
              </MatchLink>
            </li>
            <SubMenu />
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;
